module.exports = __webpack_public_path__ + "img/img_app_4.a021acbd.jpg";